// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableRow(theme) {
	return {
		MuiTableRow: {
			styleOverrides: {}
		}
	}
}
